import { createHttpClient } from '@adapters/HttpClient';
import { useToast } from '@shared/hooks/use-toast';
import { extractApiErrorMessage } from '../lib/extractApiErrorMessage';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { CourierFilesApiAdapter } from '../adapters';
import { BulkInboxCourierFilesRequest, BulkInboxCourierFilesResponse } from '../models';

export const useBulkInboxCourierFiles = () => {
  const { toast } = useToast();
  const { t } = useTranslation('codCourierFiles');

  const mutation = useMutation({
    mutationFn: async (data: BulkInboxCourierFilesRequest): Promise<BulkInboxCourierFilesResponse> => {
      const httpClient = createHttpClient(apiClientWH);
      const adapter = new CourierFilesApiAdapter(httpClient);
      return adapter.uploadCourierFilesBulk(data);
    },
    onError: (error: unknown) => {
      const errorMessage = extractApiErrorMessage(error, t('bulk.error.unexpected', 'Ocurrió un error inesperado'));

      toast({
        title: t('bulk.error.title', 'Error en la carga masiva'),
        description: errorMessage,
        variant: 'destructive',
      });
    },
  });

  return {
    bulkUploadAsync: mutation.mutateAsync,
    isBulkUploading: mutation.isPending,
  };
};
